<div class="login-body">
    <div class="login-panel p-fluid">
        <p-messages [(value)]="errorMessages" [closable]="false"></p-messages>
        <div class="p-grid login-container" style="padding-bottom: 20px;">
            <div class="p-col-12 logo-container">
                <img src="assets/title_logo.png" class="morpheus-logo" />
            </div>
            <div class="p-col-12">
                <span class="liquitics-h1">Reset your password</span>

            </div>
            <div class="p-col-12">
                <input type="password" autocomplete="off" class="p-inputtext p-corner-all p-state-default p-widget" [(ngModel)]="registrationUser.existingPassword"
                    placeholder="Existing Password">
            </div>
            <div class="p-col-12">
                <input type="password" autocomplete="off" class="p-inputtext p-corner-all p-state-default p-widget" [(ngModel)]="registrationUser.password"
                    placeholder="New Password">
            </div>
            <div class="p-col-12 button-container">
                <button type="button" (click)="onSave()" class="p-button blue-btn raised-btn p-widget p-state-default p-corner-all p-button-text-icon-left">
                        <span class="p-button-icon-left p-c fa fa-fw fa-user"></span>
                        <span class="p-button-text p-c">Change Password</span>
                    </button>
            </div>
        </div>

        <div class="stripe"></div>
        <p style="margin-left: -17px;">Don't you have an account? <a [routerLink]="['/register']">  Register here </a></p>
        <div class="stripe"></div>
    </div>
</div>
